<template>
  <div id="page-login">
    <div class="bg-img h-screen flex w-full vx-row no-gutter items-center justify-center">
      <div class="vx-col w-full m-8" style="max-width: 520px">
        <div class="vx-row no-gutter justify-center items-center">
          <slide-x-left-transition>
            <div class="vx-col w-full rounded-lg bg-dark" v-if="transition">
              <vx-card class="bg-transparent main-border">
                <div slot="no-body">
                  <div class="p-12 pb-6">
                    <div class="con-tab con-slot-tabs">
                      <login-jwt></login-jwt>
                    </div>
                    <div class="mt-8 mb-4">
                      <div class="flex justify-between items-center">
                        <p class="font-light text-dark">Copyright 2024 © Intellectual Point</p>
                      </div>
                    </div>
                  </div>
                </div>
              </vx-card>
            </div>
          </slide-x-left-transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginJwt from './LoginJWT.vue';
import VideoBackground from 'vue-responsive-video-background-player';

export default {
  data() {
    return {
      transition: false,
    };
  },
  components: { LoginJwt, VideoBackground },
  created() {
    // delete this.$http.defaults.headers.common['Authorization'];

    // //Set Base URL
    // this.$http.defaults.baseURL = '';

    // Redirect if logged in
    if (localStorage['userInfo']) {
      this.$router.push('/dashboard');
    }

    setTimeout(() => {
      this.transition = true;
    }, 50);
  },
};
</script>

<style lang="scss">
.layout--full-page {
  .bg-img {
    background-color: #000105;
    background-image: url('https://connect-cdn.intellectualpoint.com/assets/images/backgrounds/connect-login-bg.png');
    background-position: center;
    background-size: cover;
  }

  .full-page-bg-color {
    background-color: #eff2f7;
  }
}

#page-login {
  .login-tabs-container {
    min-height: 505px;

    .con-tab {
      padding-bottom: 14px;
    }

    .con-slot-tabs {
      padding-top: 3rem;
    }
  }

  .bg-login-card {
    backdrop-filter: blur(50px);
    background: rgba(0, 0, 0, 0.35);
  }

  input {
    background-color: transparent;
  }
}
</style>
